import {
  castArray,
  defaultTo,
  filter,
  get,
  invert,
  isNotUndefined,
  pipe,
  reduce,
  toEntries,
  toNumber,
} from '@logistics-frontend/utils'

import {
  DeliveryType,
  OffersCalculateRequest,
  Order,
  VerticalRequirement,
  VerticalTariffRequirement,
} from 'src/shared/types'
import {fromPaymentInfo, toGeoLocation} from 'src/shared/utils'

import {fromParcels} from './from-parcel'

type RequirementsMap = Record<VerticalTariffRequirement['name'], VerticalRequirement['selectedValue']>

export const fromOfferBody = (order: Order): OffersCalculateRequest => {
  const sourcePoint = get('sourcePoint', order)
  const destinationPoints = get('destinationPoints', order) || []
  const selectedVerticalName = get('offerFlow.vertical.name', order)
  const selectedVerticalRequirements = pipe(order, get('offerFlow.vertical.requirements'), defaultTo({}))
  const deliveryInterval = get('offerFlow.deliveryInterval', order)
  const deliveryTime = get('offerFlow.deliveryTime', order)
  const paymentInfo = pipe(order, get('paymentInfo'), fromPaymentInfo)

  /**
   * @BusinessLogic
   * Теперь идентификаторы точек начинаются от 0 до N. Поэтому нужно привести их к такому виду
   * Точка куда начинается от 1, потому что 0 индекс занимает точка отправления
   */
  const preparedDestinationPoints = destinationPoints.map((point, index) => ({
    ...point,
    _id: index + 1,
  }))

  const items = fromParcels(0, preparedDestinationPoints)

  const routePoints = [sourcePoint, ...destinationPoints]
    .map(get('address.coordinates'))
    .map(toGeoLocation)
    .filter(isNotUndefined)

  const preparedRequirements = pipe(
    selectedVerticalRequirements,
    toEntries,
    reduce<[VerticalTariffRequirement['name'], VerticalRequirement], RequirementsMap>((acc, [key, value]) => {
      acc[key] = value.name === 'cargo_loaders' ? toNumber(value.selectedValue) : value.selectedValue

      return acc
    }, {}),
  )

  const requirements = Object.assign(
    preparedRequirements,
    {
      skip_door_to_door: pipe(preparedRequirements, get('door_to_door'), invert),
      taxi_class: pipe(selectedVerticalName, castArray, filter(isNotUndefined)),
      /**
       * это свойство надо выставлять в undefined,
       * так как на сервере ожидается skip_door_to_door, а с бэкенда приходит door_to_door
       */
      door_to_door: undefined,
      cargo_options: pipe(preparedRequirements, get('cargo_options')),
    },
    deliveryTime && {due: deliveryTime},
  )

  // @ts-expect-error - wrong typings
  return Object.assign(
    {
      payment_info: paymentInfo,
      route_points: routePoints,
      items,
      requirements,
    },
    selectedVerticalName === DeliveryType.Night &&
      deliveryInterval && {
        same_day_data: {
          delivery_interval: deliveryInterval,
        },
      },
  )
}
